import {register} from '../vendor/theme-scripts/theme-sections';
import {RadioSwatch, swatchGridSection} from '../features/swatch';
import {ProductGridItem} from '../features/product-grid-item';
import {ProductGridItemVariant} from '../features/product-grid-item-variant';
import {ProductGridItemImage} from '../features/product-grid-item-image';
import {siblings} from '../features/siblings';
import {customScrollbar} from '../features/custom-scrollbar';

register('collection-row', [swatchGridSection, siblings, customScrollbar]);

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('product-grid-item')) {
  customElements.define('product-grid-item', ProductGridItem);
}

if (!customElements.get('product-grid-item-variant')) {
  customElements.define('product-grid-item-variant', ProductGridItemVariant);
}

if (!customElements.get('product-grid-item-image')) {
  customElements.define('product-grid-item-image', ProductGridItemImage);
}
